import React from 'react';
import { BUILD } from '../../util/const';
import SearchForm from './components/SearchForm/SearchForm';
import SearchFlyout from './components/SearchFlyout/SearchFlyout';
import * as Styled from './Search.styled';
import ConstructorIOProvider from '../../util/ConstructorIO.context';
/**
 * Search Component
 */
var Search = function (_a) {
    var onRequestClose = _a.onRequestClose;
    return (React.createElement(Styled.Search, null,
        React.createElement(ConstructorIOProvider, { resultsPerPage: 6 },
            React.createElement(Styled.SearchFormContainer, null,
                React.createElement(Styled.LogoContainer, null,
                    React.createElement(Styled.LogoLink, { href: "/", "aria-label": "Bombas", as: BUILD === 'shopify' ? 'a' : undefined },
                        React.createElement(Styled.Icon, { name: "logo-type", size: 20 }))),
                React.createElement(SearchForm, { onRequestClose: onRequestClose })),
            React.createElement(SearchFlyout, { onBackdropClick: onRequestClose }))));
};
export default Search;
